import React from "react";
import cn from "classnames";
import { styled } from "@linaria/react";
import { color, easingBounce, easingBounceMs } from "..";
import Toggle from "../Toggle";
import Card from "../Card";
import { HIDE_ON_EXPORT } from "../lib/downloadPage";
import { ArrowDownSLine } from "../IconV2/react";

const CollapsedContent = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 32px;

  transform-origin: top center;

  transition:
    transform ${easingBounceMs}ms ${easingBounce},
    opacity ${easingBounceMs}ms ${easingBounce};

  /* classes are added directly by CSSTransition, DO NOT MESS WITH NAMES & ORDERING */
  &.enter {
    opacity: 0;
    transform: scale(1, 0.3);
  }
  &.enter-active {
    opacity: 1;
    transform: none;
  }
  &.exit {
    opacity: 1;
    transform: none;
  }
  &.exit-active {
    opacity: 0;
    transform: scale(1, 0.3);
  }
`;

const WrapperIcon = styled.div`
  margin-left: auto;
`;

export const ToggleIcon = styled(ArrowDownSLine)`
  width: 28px;
  height: 28px;
  color: ${color.carbon900};
  transform-origin: 50% 50%;
  transition: transform ${easingBounceMs}ms ${easingBounce};
  :hover {
    cursor: pointer;
    rect {
      opacity: 1;
    }
    g path {
      opacity: 1;
    }
  }
  rect {
    opacity: 0;
  }
  g path {
    opacity: 0.5;
  }
  &.opened {
    transform: scaleY(-1);
  }
`;

const OverflowCard = styled(Card)`
  overflow-x: auto;
`;

interface P {
  title: string;
  collapsedPart?: React.ReactNode;
  actions?: React.ReactNode;
  opened?: boolean;
  onToggle?: () => void;
  className?: string;
  children: React.ReactNode;
}

function WidgetCard({
  title,
  children,
  collapsedPart,
  actions,
  opened,
  className,
  onToggle,
}: P & React.HTMLAttributes<HTMLDivElement>) {
  return (
    <OverflowCard
      className={className}
      title={
        <>
          {title}
          {actions}
          {collapsedPart && onToggle && (
            <WrapperIcon className={HIDE_ON_EXPORT}>
              <ToggleIcon onClick={onToggle} className={cn({ opened })} />
            </WrapperIcon>
          )}
        </>
      }
    >
      {children}
      {collapsedPart && (
        <Toggle timeout={easingBounceMs} active={opened}>
          <CollapsedContent className={cn({ opened })}>{collapsedPart}</CollapsedContent>
        </Toggle>
      )}
    </OverflowCard>
  );
}

export default WidgetCard;
